import React from 'react';
import '../../../assets/css/style.css';
import RadioChipContainer from '../elements/RadioChipContainer';

const VirtuesEthnicity = () => {
    const ethnicityNames = ['African','Caucasain','Asian','Coloured','Indian','Other','Prefer not to say'];
    
    return (
        <div className="chip-container">
            <RadioChipContainer labels={ethnicityNames} type="ethnicity" />
        </div>
    );
};

export default VirtuesEthnicity;